namespace GeniuzPOS.Inventory {
    export namespace IcStockBacProcessingService {
        export const baseUrl = 'Inventory/IcStockBacProcessing';

        export declare function Create(request: Serenity.SaveRequest<IcStockBacProcessingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcStockBacProcessingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockBacProcessingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockBacProcessingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/IcStockBacProcessing/Create",
            Update = "Inventory/IcStockBacProcessing/Update",
            Delete = "Inventory/IcStockBacProcessing/Delete",
            Retrieve = "Inventory/IcStockBacProcessing/Retrieve",
            List = "Inventory/IcStockBacProcessing/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockBacProcessingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
